import React from "react";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { LogOut, Map, ClipboardCheck } from "lucide-react";

export default function SurveyorLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Brand size="sm" />
          <div className="flex items-center gap-2">
            <span className="hidden sm:block text-xs font-mono uppercase tracking-widest text-slate-500">
              {user?.name}
            </span>
            <button
              onClick={async () => {
                await logout();
                nav("/login");
              }}
              data-testid="surveyor-logout-btn"
              className="p-2 rounded-md hover:bg-slate-100"
              aria-label="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
        <nav className="max-w-3xl mx-auto px-4 flex gap-1 border-t border-slate-100">
          <NavLink
            end
            to="/surveyor"
            data-testid="surveyor-nav-wards"
            className={({ isActive }) =>
              `flex items-center gap-1.5 text-sm py-3 px-3 border-b-2 ${isActive ? "border-blue-700 text-blue-700 font-medium" : "border-transparent text-slate-600 hover:text-slate-900"}`
            }
          >
            <Map size={14} /> Assigned Wards
          </NavLink>
          <NavLink
            to="/surveyor/submissions"
            data-testid="surveyor-nav-submissions"
            className={({ isActive }) =>
              `flex items-center gap-1.5 text-sm py-3 px-3 border-b-2 ${isActive ? "border-blue-700 text-blue-700 font-medium" : "border-transparent text-slate-600 hover:text-slate-900"}`
            }
          >
            <ClipboardCheck size={14} /> My Submissions
          </NavLink>
        </nav>
      </header>
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-6 md:py-8">
        <Outlet />
      </main>
    </div>
  );
}
